import React from 'react'
// libs
import styled from 'styled-components'
// views
import { AttachmentIcon, LinkIcon } from 'components/FormElements/ReduxForm/Forms/CreateCommentForm/views'
// themes
import { colors } from 'themes'

// views
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
`

const OptionWrapper = styled.div`
  align-items: center;
  color: ${colors.blue500};
  cursor: pointer;
  display: flex;
  font-weight: 500;
  height: 40px;
  padding: 6px 8px;

  &:hover {
    background-color: ${colors.gray190};
  }
`

// types
interface IIncomingProps {
  addLink: () => void
  closePopup: () => void
  addAttachment: () => void
}

const AttachmentsMenu: React.FunctionComponent<IIncomingProps> = ({ addAttachment, closePopup, addLink }) => {
  const onAddAttachmentClick = () => {
    closePopup()
    addAttachment()
  }

  const onAddLinkCLick = () => {
    closePopup()
    addLink()
  }

  return (
    <Wrapper>
      <OptionWrapper onClick={onAddAttachmentClick}>
        <AttachmentIcon />
        Add Attachment
      </OptionWrapper>
      <OptionWrapper onClick={onAddLinkCLick}>
        <LinkIcon />
        Add Link
      </OptionWrapper>
    </Wrapper>
  )
}

export default AttachmentsMenu
